import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
